import { defineComponent, ref, openBlock, createElementBlock, createVNode, unref, withCtx, createTextVNode } from "vue";
import { CdrLink } from "@rei/cedar";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxReturnPolicy",
  props: {
    cmsKey: {}
  },
  emits: ["loadCmsContent", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const modalData = ref({
      label: "Return Policy",
      labelIsTitle: false,
      modalContent: "HTMLContentModal",
      id: "return-policy-popup-modal",
      key: props.cmsKey
    });
    const handleClick = (event) => {
      emit("loadCmsContent", modalData.value);
      emit("metricsClick", {
        linkName: "satisfaction-guarantee",
        event
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [createVNode(unref(CdrLink), {
        id: "return-policy-link",
        tag: "button",
        type: "button",
        onClick: handleClick
      }, {
        default: withCtx(() => _cache[0] || (_cache[0] = [createTextVNode(" REI return policy ")])),
        _: 1
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxReturnPolicy.mjs.map
